import { Header } from '@/components/Navigation/Header'
import { Sidebar } from '@/components/Navigation/Sidebar'
import { ResponsiveContainer } from '@/components/ResponsiveContainer'
import { uit } from '@/theme'
import { Box, useDisclosure } from '@chakra-ui/react'
import { Outlet } from 'react-router-dom'

/**
 * Main Layout Component
 * Modern layout with collapsible sidebar and header
 * Uses centralized UI constants from theme/foundations.js
 */
export function MainLayout() {
  const { open: isSidebarOpen, onToggle: onSidebarToggle } = useDisclosure({ defaultOpen: true })

  const sidebarWidth = isSidebarOpen ? uit.layout.sidebar.widthOpen : uit.layout.sidebar.widthClosed

  return (
    <Box minH="100vh" bg="bg.secondary">
      <Sidebar isOpen={ isSidebarOpen } onToggle={ onSidebarToggle } />
      <Header sidebarWidth={ sidebarWidth } />

      <Box
        ml={ sidebarWidth }
        mt={uit.layout.header.height}
        transition={`all ${uit.animations.transition.slow} ${uit.animations.timing.smooth}`}
        minH={`calc(100vh - ${uit.layout.header.height})`}
      >
        <ResponsiveContainer py={ 8 }>
          <Outlet />
        </ResponsiveContainer>
      </Box>
    </Box>
  )
}

export default MainLayout
